<template>
  <div class="addDepart-container">
    <el-dialog :close-on-click-modal="false" :visible.sync="_visible" :title="handleTitle" width="600px">
      <div class="manager-info">
        <el-form
          ref="addDepartForm"
          :model="addObj"
          :rules="addObjRules"
          label-position="right"
          label-width="120px"
        >
          <el-form-item prop="name" label="部门名称：">
            <el-input
              v-model="addObj.name"
              :maxlength="30"
              name="name"
              type="text"
              auto-complete="off"
              placeholder="请输入部门名称"
              class="form-input"
              clearable
            />
          </el-form-item>
          <el-form-item label="部门状态：" prop="status">
            <el-select v-model="addObj.status" placeholder="请选择" class="form-input">
              <el-option
                v-for="item in roleStateOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                class="form-input"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="部门描述：" prop="remark">
            <el-input
              v-model.trim="addObj.remark"
              :rows="4"
              :maxlength="50"
              type="textarea"
              placeholder="请输入部门描述"
              class="form-input"
              clearable
              show-word-limit
            />
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="_visible = false">
          取 消
        </el-button>
        <el-button type="primary" @click="handleDefined('addDepartForm')">
          确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import Permissions from '@/api/systemManage/permissionMgmt/roleManage';
import { validateUserName } from '@/utils/validate';
export default {
  name: 'AddDepart',
  components: {
    // Permissions
  },
  props: {
    addObj: {
      type: Object,
      // 对象或数组默认值必须从一个工厂函数获取
      default: function() {
        return {
        };
      }
    },
    visible: {
      type: Boolean,
      required: true
    },
    oprType: {
      type: String,
      required: true
    },
    btnLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      roleStateOptions: [{ // 部门状态
        value: 1,
        label: '启用'
      }, {
        value: 0,
        label: '禁用'
      }],
      addObjRules: {
        name: [
          { required: true, trigger: 'blur', message: '部门名称不能为空' },
          { trigger: 'blur', validator: validateUserName }
        ],
        status: [{ required: true, trigger: 'change', message: '部门状态不能为空' }],
        remark: [{ required: true, trigger: 'blur', message: '部门描述不能为空' }]
      }
    };
  },
  computed: {
    _visible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit('update:visible', value);
      }
    },
    handleTitle() {
      return this.oprType === 'add' ? '新建部门' : '编辑部门';
    }
  },
  methods: {
    // 确定
    handleDefined(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // const _addObj = this.addObj;
          // const param = {
          //   name: _addObj.name, // 部门名称
          //   // orgCategoryId: 'ORG007', // 说明
          //   remark: _addObj.remark, // 状态
          //   status: _addObj.status
          //   // level: 1 // 部门等级
          // };
          this.$emit('handleAddComfirm', this.addObj);
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.addDepart-container {
  .manager-info {
    display: flex;
    ul {
      margin-left: 50px;
      li {
        margin-bottom: 20px;
      }
    }
    form {
      width: 100%;
    }
  }
  .handle-span {
    display: inline-block;
    margin-left: 10px;
    color: #1890ff;
    cursor: pointer;
    text-decoration: underline;
  }
  .form-input {
    width: 80%;
  }
}
</style>
